import { FaBoxOpen } from 'react-icons/fa';

const EmptyLayout = ({ message, ...props }) => {
    return (
        <div className="empty-layout">
            <div className="empty-layout-card">
                <span className="empty-layout-icon" aria-hidden="true">
                    <FaBoxOpen />
                </span>
                <p className="empty-layout-message">{message}</p>
            </div>
        </div>
    );
}

export default EmptyLayout;
